<template>
  <TopGradientBlockLayout class="flex flex-col">
    <template v-slot:top>
      <ExpenseSettingsForm :full-settings="false"/>
    </template>
    <ExpenseList :key="key_list_key"
                 class="mb-13 lg:mb-27"
                 @edit="openEditExpenseModal"
                 @editGroup="openEditGroupModal"/>
    <div class="border-t border-border -mx-12 mt-auto p-12 pb-0">
      <ButtonGrouped @click="$emit('nextStep')">
        <template v-slot:left>{{ $t('finishText') }}</template>
        <template v-slot:right>
          <IconArrow direction="right" class="mr-2 w-4-5 h-4-5"/>
          {{ $t('ready') }}
        </template>
      </ButtonGrouped>
    </div>
    <transition name="modal">
      <ExpenseGroupEditModal v-if="!!edit_group"
                             :group="edit_group"
                             @close="edit_group=null"
                             @onRemove="updateExpenses"
                             @onUpdate="updateExpenses"/>
    </transition>
    <transition name="modal">
      <ExpenseSettingsEditModal v-if="!!edit_expense"
                                :edit_expense="edit_expense"
                                @close="edit_expense=null"/>
    </transition>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import ExpenseSettingsForm from "@/components/cabinet/SpaceSettings/ExpenseSettings/ExpenseSettingsForm";
import ExpenseList from "@/components/cabinet/SpaceSettings/ExpenseSettings/ExpenseList";
import ExpenseGroupEditModal from "@/components/cabinet/SpaceSettings/ExpenseSettings/ExpenseGroupEditModal";
import ExpenseSettingsEditModal from "@/components/cabinet/SpaceSettings/ExpenseSettings/ExpenseSettingsEditModal";
import {mapState} from "vuex";
import ButtonGrouped from "@/components/UI/ButtonGrouped";
import IconArrow from "@/components/icons/IconArrow";

export default {
  name: "WizardStep3",
  components: {
    IconArrow,
    ButtonGrouped,
    ExpenseSettingsEditModal,
    ExpenseGroupEditModal,
    ExpenseList,
    ExpenseSettingsForm,
    TopGradientBlockLayout
  },
  data() {
    return {
      openForm: false,
      edit_expense: null,
      edit_group: null,
      key_list_key: 0
    }
  },
  computed: {
    ...mapState('space/expenses', ['expenses', 'expense_groups']),
  },
  methods: {
    openEditExpenseModal(val) {
      this.edit_expense = val;
    },
    openEditGroupModal(val) {
      this.edit_group = val;
    },
    async updateExpenses() {
      await this.$store.dispatch('space/expenses/getExpenses');
      await this.$store.dispatch('space/expenses/getExpenseGroups');
    },
    async fetchMainData() {
      try {
        if (this.expenses.data.length === 0) {
          await this.$store.dispatch('space/expenses/getExpenses');
          await this.$store.dispatch('space/expenses/getExpenseGroups');
        }
      } catch (e) {
        throw e;
      }
    },
  },
  watch: {
    'expenses.data': {
      immediate: true,
      handler: function (newVal) {
        if (!!newVal) {
          this.key_list_key++;
        }
      }
    }
  },
  async created() {
    await this.fetchMainData();
  },
  i18n: {
    messages: {
      en: {
        finishText: 'I added all categories',
        ready: 'Done!'
      },
      ru: {
        finishText: 'Я добавил все категории',
        ready: 'Готово!'
      }
    }
  }
}
</script>